<template>
  <div class="popUpWrap">
    <section class="popup dark basic">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="textArea flex">
          <h5>{{ t("skillMonitor-assessment-send-report-title") }}</h5>
          <p v-html="getDescriptionToHtml" />
        </div>
        <label>
          <input type="text" v-model="email" :class="{error: !isValidEmail && email.length > 0}" :placeholder="t('account-email')">
        </label>
        <p v-if="!isValidEmail && email.length > 0" class="errorMessage"><span></span>{{ t("error-invalid-email") }}</p>
        <div class="btnArea">
          <button :class="{ disabled: !isValidEmail || email.length === 0 }" type="button" @click.stop="onSendReport">
            {{ t("skillMonitor-assessment-send-report-button") }}
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import {emailValidation} from '~/utils/ValidationUtil';
import {useDialogStore} from '~/store/dialog/dialogStore';
import {useToastStore} from '~/store/toast/toastStore';
import {ToastType} from '~/components/Common/Toast/model/ToastType';
import {useReportService} from '~/composables/service/useReportService';
import {ReportDomainType} from '~~/package/mapper/report/model/ReportDomainType';

const { t } = useI18n();

const dialogStore = useDialogStore();
const toastStore = useToastStore();
const reportService = useReportService();

const email = ref("");

const getDescriptionToHtml = computed(() =>
  t('skillMonitor-assessment-send-report-description', { pdf: `<span style="font-weight: 600">${t('skillMonitor-assessment-send-report-description-pdf')}</span>`})
)

const isValidEmail = computed(() => emailValidation(email.value))

// ASMT-REPORT-07: 리포트 발송 팝업 — 이메일 검증 후 POST /reports/export, 성공/실패 토스트
const onSendReport = () => {
  if(!isValidEmail.value || email.value.length === 0) return;
  const accessUrl = dialogStore.options.props.uuid ?
    `/dashboard/proSkillManager/report/pdf-export/individual/${dialogStore.options.props.assessmentId}?uuid=${dialogStore.options.props.uuid}` :
    `/dashboard/proSkillManager/report/pdf-export/assessment/${dialogStore.options.props.assessmentId}`

  reportService.submitReportExport(
      email.value,
      accessUrl,
      ReportDomainType.CUSTOM_ASSESSMENT,
      dialogStore.options.props.assessmentId ?? 0
  ).then((isSuccess: boolean) => {
    if(isSuccess) {
      toastStore.openToast({
        toastType: ToastType.SUCCESS,
        contents: t('skillMonitor-assessment-send-report-success'),
      });
    }
    else {
      toastStore.openToast({
        toastType: ToastType.FAILED,
        contents: t('skillMonitor-assessment-send-report-fail'),
      });
    }
  }).catch(() => {
    toastStore.openToast({
      toastType: ToastType.FAILED,
      contents: t('skillMonitor-assessment-send-report-fail'),
    });
  }).finally(() => {
    onClickClose()
  })
}

const onClickClose = () => {
  dialogStore.close();
}
</script>